<template>
  <div class="chat-container">
    <!-- 聊天消息区域 -->
    <div class="messages-container" ref="messagesContainer">
      <div class="welcome-message" v-if="chats.length === 0 && !loading">
        <div class="welcome-icon">
          <i class="el-icon-chat-dot-round"></i>
        </div>
        <h2>Welcome to AI Assistant</h2>
        <p>Ask me any questions about the notes or content!</p>
      </div>

      <div class="message-list">
        <div class="message-item" v-for="(item, i) in chats" :key="i">
          <!-- 用户消息 - 靠右显示 -->
          <div class="user-message">
            <div class="message-content user-content">
              {{ item.ask }}
            </div>
            <div class="avatar user-avatar">
              <i class="el-icon-user"></i>
            </div>
          </div>

          <!-- AI消息 - 靠左显示 -->
          <div class="ai-message">
            <div class="avatar ai-avatar">
              <i class="el-icon-cpu"></i>
            </div>
            <div class="message-content ai-content">
              <div v-html="renderMarkdown(item.answer)"></div>
              <div class="copy-button" @click="copyMessage(item.answer, i)" v-if="item.answer" :class="{'copied': item.copyStatus === '已复制！'}">
                <i class="el-icon-document-copy"></i>
              </div>
              <div v-if="item.isStreaming" class="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>

        <!-- 加载中的消息 -->
        <div class="message-item" v-if="loading">
          <div class="user-message">
            <div class="message-content user-content">
              {{ loading_ask }}
            </div>
            <div class="avatar user-avatar">
              <i class="el-icon-user"></i>
            </div>
          </div>

          <div class="ai-message">
            <div class="avatar ai-avatar">
              <i class="el-icon-cpu"></i>
            </div>
            <div class="message-content ai-content loading-content">
              <div class="current-answer" v-if="currentAnswer">
                <div v-html="renderMarkdown(currentAnswer)"></div>
              </div>
              <div class="typing-indicator" v-else>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 输入区域 -->
    <div class="input-area">
      <div class="input-container">
        <input type="text" class="question-input" placeholder="Enter your question..." v-model="question"
          @keyup.enter="askQuestion()" />
        <button class="send-button" @click="askQuestion()" :disabled="!question.trim() || loading">
          <i class="el-icon-position"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { renderMarkdown } from '@/utils/markdown';
export default {
  components: {
    // selectlanguage,
  },
  props: {
    noteobj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      testmd:"## 角落数字的计算\n\n根据提供的上下文，角落数字的计算公式为：\n\n**角落数字等于对面两边之和的一半。**\n\n具体来说，角落数字只使用对面两条边的数字进行计算，而不涉及与其相邻的边的数字。例如，A的对面是10和12，A的值为这两个数字之和的二分之一，即：\n\n$$ A = \\frac{10 + 12}{2} = 11 $$\n\n同样，C的对面是2和10，C的值为这两个数字之和的二分之一，即：\n\n$$ C = \\frac{2 + 10}{2} = 6 $$\n\n因此，角落数字的计算依赖于对面边的数字之和。",
      question: "",
      loading: false,
      loading_ask: "",
      chooeseLanguageName: "English",
      chooeseLanguage: "en",
      chats: [],
      timer: {},
      apiBaseUrl: "https://easynoteai.online",
      currentAnswer: '', // 当前正在生成的答案
      eventSource: null, // SSE 连接对象
      isStreaming: false, // 是否正在流式输出
      currentMarkdown: '', // 用于存储当前的markdown文本
      copyTimeouts: {}, // 用于存储复制状态的超时器
    };
  },
  computed: {
    // reversedChats() {
    //   return [...this.chats].reverse();
    // },
  },
  mounted() {
    this.chats = this.noteobj.note_chats || [];
    this.scrollToBottom();
  },
  updated() {
    this.scrollToBottom();
  },
  methods: {
    renderMarkdown,
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.messagesContainer) {
          this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
        }
      });
    },
    chooeselanguage(language, Languagename) {
      this.chooeseLanguage = language;
      this.chooeseLanguageName = Languagename;
    },
    async askQuestion() {
      if (this.question.trim() !== "" && !this.isStreaming) {
        this.loading = true;
        this.isStreaming = true;
        this.loading_ask = this.question;
        this.currentAnswer = '';
        const noteid = this.noteobj.noteid;

        try {
          const endpoint = 'sse/sendaskstream/'
          const baseUrl = `${this.apiBaseUrl}/${endpoint}`
          
          // 准备POST请求数据
          const requestData = {
            ask_content: this.question,
            noteid: noteid,
            language: this.chooeseLanguageName
          }

          console.log('POST请求数据:', requestData)

          // 先发送POST请求
          const response = await fetch(baseUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData),
            credentials: 'omit',  // 改为omit，不发送cookies
            mode: 'cors'
          })

          console.log('POST请求响应:', response)
          if (!response.ok) {
            console.log('POST请求失败:', response)
            throw new Error(`HTTP错误: ${response.status}`)
          }

          // 解析POST响应数据
          const responseData = await response.json()
          console.log('POST响应数据:', responseData)
          
          if (responseData.code !== 200) {
            throw new Error(responseData.message || '请求失败')
          }

          // 获取askid
          const askId = responseData.askid
          
          if (!askId) {
            throw new Error('未获取到askId')
          }

          // 清理现有的SSE连接
          if (this.eventSource) {
            this.eventSource.close()
          }
          
          // 建立SSE连接
          const timestamp = Date.now()
          const esUrl = `${baseUrl}?askid=${askId}&t=${timestamp}`
          
          console.log('SSE连接URL:', esUrl)
          
          this.eventSource = new EventSource(esUrl, { 
            withCredentials: false
          })
          
          // 设置事件监听器
          this.eventSource.onmessage = (event) => {
            try {
              const data = JSON.parse(event.data)
              this.handleStreamMessage(data)
            } catch (e) {
              console.error('解析消息失败:', e)
              this.$message.error('解析响应失败')
              this.stopStream()
            }
          }

          this.eventSource.onerror = (e) => {
            console.error('SSE错误:', e)
            this.$message.error('连接中断')
            this.stopStream()
          }

          this.eventSource.onopen = () => {
            console.log('SSE连接已建立')
          }

          // 清空输入
          this.question = ""

        } catch (error) {
          console.error('请求失败:', error)
          this.$message.error(error.message || "请求失败，请稍后重试")
          this.stopStream()
        }
      } else {
        this.$message.error("Please enter a question")
      }
    },
    gopaypage() {
      this.$router.push({
        name: "IndexPage",
        params: { pagekey: "price" },
      });
    },
    getaskanswer_timer(askid) {
      this.timer.getaskanswer = setInterval(() => {
        this.getaskanswer(askid);
      }, 2000);
    },
    async getaskanswer(askid) {
      try {
        const res = await this.$axios.post("/api/getchatanswer/", {
          askid: askid,
        });
        const resdata = res.data;
        if (resdata.code == 200) {
          if (resdata.status == 0) {
            return;
          }
          if (resdata.status > 1) {
            clearInterval(this.timer.getaskanswer);
            this.$message.error("No answer available");
            this.loading = false;
            return;
          }
          this.loading = false;
          const answer = resdata.answer;
          const ask = resdata.ask;
          this.chats.push({ ask: ask, answer: answer });
          this.savemessage();
          clearInterval(this.timer.getaskanswer);
        } else {
          clearInterval(this.timer.getaskanswer);
          this.$message.error("No answer available");
          this.loading = false;
        }
      } catch (error) {
        clearInterval(this.timer.getaskanswer);
        this.loading = false;
        this.$message.error("Failed to get answer");
      }
    },
    async savemessage() {
      try {
        const res = await this.$axios.post("/api/savemessage/", {
          chats: JSON.stringify(this.chats),
          noteid: this.noteobj.noteid,
        });
        if (res.data.code !== 200) {
          console.log("Failed to save message");
        }
      } catch (error) {
        console.log("Error saving message", error);
      }
    },
    // 处理流消息
    handleStreamMessage(data) {
      const type = data.type;
      const payload = data.payload || {};

      switch (type) {
        case 'query_received':
          console.log('问题已收到')
          break;

        case 'retrieval_start':
          console.log('开始检索相关知识')
          break;

        case 'generating_token':
          this.currentAnswer += payload.content;
          this.$nextTick(() => {
            this.currentMarkdown = this.currentAnswer;
          });
          break;

        case 'finish_answer':
          console.log('完成回答')
          this.chats.push({
            ask: this.loading_ask,
            answer: this.currentAnswer
          });
          this.stopStream();
          this.savemessage();
          break;

        case 'error':
          console.error('SSE错误:', payload.content)
          this.$message.error(payload.content);
          this.stopStream();
          break;
      }
      
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    // 停止流式输出
    stopStream() {
      this.loading = false;
      this.isStreaming = false;
      
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
      
      this.currentAnswer = '';
    },
    // 处理复制功能
    async copyMessage(text, index) {
      try {
        // 创建一个临时div来处理markdown文本
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.renderMarkdown(text);
        
        // 获取所有数学公式元素
        const mathElements = tempDiv.querySelectorAll('.katex-display, .katex-inline');
        
        // 替换数学公式为原始LaTeX文本
        mathElements.forEach(element => {
          const katexElement = element.querySelector('.katex');
          if (katexElement) {
            const texSource = katexElement.getAttribute('data-tex-source') || 
                            element.querySelector('.katex-mathml annotation[encoding="application/x-tex"]')?.textContent;
            
            if (texSource) {
              // 如果是行内公式
              if (element.classList.contains('katex-inline')) {
                element.textContent = `$${texSource}$`;
              } else {
                // 如果是显示公式
                element.textContent = `\n$$${texSource}$$\n`;
              }
            }
          }
        });
        
        // 处理代码块
        const codeBlocks = tempDiv.querySelectorAll('pre code');
        codeBlocks.forEach(block => {
          const language = block.className.replace('language-', '').trim();
          block.textContent = `\`\`\`${language}\n${block.textContent}\n\`\`\``;
        });
        
        // 获取处理后的文本并规范化换行
        let processedText = tempDiv.innerText
          .replace(/\n{3,}/g, '\n\n')  // 将多个连续换行减少为两个
          .trim();
        
        // 使用Clipboard API复制文本
        await navigator.clipboard.writeText(processedText);
        
        // 更新复制状态
        this.$set(this.chats[index], 'copyStatus', '已复制！');
        
        // 清除之前的超时器（如果存在）
        if (this.copyTimeouts[index]) {
          clearTimeout(this.copyTimeouts[index]);
        }
        
        // 设置新的超时器
        this.copyTimeouts[index] = setTimeout(() => {
          this.$set(this.chats[index], 'copyStatus', '复制');
        }, 1500);
        
      } catch (err) {
        console.error('复制失败:', err);
        this.$message.error('复制失败，请重试');
      }
    },
  },
  beforeDestroy() {
    // 清除所有计时器
    Object.keys(this.timer).forEach(key => {
      clearInterval(this.timer[key]);
    });
    // 关闭SSE连接
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }
};
</script>

<style lang="less" scoped>
@import '@/styles/markdown.less';

.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f8f9fc;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  margin: 5px;
}

.messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  scroll-behavior: smooth;

  .welcome-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #5a6474;
    text-align: center;
    padding: 2rem;

    .welcome-icon {
      background: linear-gradient(135deg, #4e7df9, #6366f1);
      border-radius: 50%;
      width: 80px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1rem;

      i {
        font-size: 2rem;
        color: white;
      }
    }

    h2 {
      color: #2d3748;
      margin-bottom: 0.5rem;
      font-weight: 600;
    }

    p {
      opacity: 0.8;
      color: #5a6474;
    }
  }

  .message-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .message-item {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .user-message {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    align-items: flex-start;
    padding-left: 20%;
  }

  .ai-message {
    display: flex;
    justify-content: flex-start;
    gap: 12px;
    align-items: flex-start;
    padding-right: 8%;
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      font-size: 1.2rem;
      color: white;
    }
  }

  .user-avatar {
    background: linear-gradient(135deg, #4e7df9, #6366f1);
    box-shadow: 0 4px 10px rgba(99, 102, 241, 0.3);
  }

  .ai-avatar {
    background: linear-gradient(135deg, #10b981, #059669);
    box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
  }

  .message-content {
    padding: 12px 16px;
    border-radius: 12px;
    max-width: 100%;
    font-size: 0.95rem;
    line-height: 1.5;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }

  .user-content {
    background-color: #4e7df9;
    color: white;
    border-radius: 12px 12px 2px 12px;
  }

  .ai-content {
    background-color: white;
    color: #2d3748;
    border-radius: 12px 12px 12px 2px;
    border: 1px solid #e2e8f0;
    position: relative;
    
    .copy-button {
      position: absolute;
      bottom: 8px;
      right: 8px;
      background-color: #f8f9fc;
      border: 1px solid #e2e8f0;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;
      color: #64748b;
      opacity: 0.6;
      z-index: 10;
      
      &:hover {
        background-color: #edf2f7;
        color: #4e7df9;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        opacity: 1;
      }
      
      &:active {
        transform: scale(0.95);
      }

      &.copied {
        background-color: #10b981;
        color: white;
        border-color: #10b981;
      }
      
      i {
        font-size: 1.1rem;
      }
    }
    
    &:hover {
      .copy-button {
        opacity: 1;
      }
    }
    
    .typing-indicator {
      display: flex;
      gap: 4px;
      padding: 8px 0 0 0;
      
      span {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #4e7df9;
        display: inline-block;
        animation: bounce 1.4s infinite ease-in-out;
        
        &:nth-child(1) {
          animation-delay: -0.32s;
        }
        
        &:nth-child(2) {
          animation-delay: -0.16s;
        }
      }
    }
    
    @keyframes bounce {
      0%, 80%, 100% {
        transform: scale(0);
      }
      40% {
        transform: scale(1.0);
      }
    }
    
    :deep(pre) {
      margin: 0.5rem 0;
      padding: 1rem;
      background-color: #f8fafc;
      border-radius: 6px;
      overflow-x: auto;
      font-family: 'Courier New', Courier, monospace;
      font-size: 0.9em;
      border: 1px solid #e2e8f0;
    }
    
    :deep(code) {
      background-color: #f1f5f9;
      padding: 2px 4px;
      border-radius: 4px;
      font-family: 'Courier New', Courier, monospace;
      font-size: 0.9em;
    }
    
    :deep(p) {
      margin: 0.8em 0;
      line-height: 1.6;
    }
    
    :deep(h1), :deep(h2), :deep(h3), :deep(h4), :deep(h5), :deep(h6) {
      margin-top: 1.5em;
      margin-bottom: 0.5em;
      font-weight: 600;
      color: #1a202c;
    }
    
    :deep(h1) {
      font-size: 1.8em;
      border-bottom: 1px solid #e2e8f0;
      padding-bottom: 0.3em;
    }
    
    :deep(h2) {
      font-size: 1.5em;
    }
    
    :deep(h3) {
      font-size: 1.3em;
    }
    
    :deep(h4) {
      font-size: 1.1em;
    }
    
    :deep(a) {
      color: #4e7df9;
      text-decoration: none;
      border-bottom: 1px dashed #4e7df9;
      
      &:hover {
        color: #3b6ef6;
        border-bottom: 1px solid #3b6ef6;
      }
    }
    
    :deep(ul), :deep(ol) {
      padding-left: 1.5rem;
      margin: 0.8em 0;
    }
    
    :deep(li) {
      margin: 0.3em 0;
    }
    
    :deep(blockquote) {
      margin: 0.8em 0;
      padding-left: 1rem;
      border-left: 3px solid #e2e8f0;
      color: #64748b;
    }
    
    :deep(table) {
      border-collapse: collapse;
      width: 100%;
      margin: 1em 0;
      
      th, td {
        border: 1px solid #e2e8f0;
        padding: 8px;
        text-align: left;
      }
      
      th {
        background-color: #f8fafc;
      }
      
      tr:nth-child(even) {
        background-color: #f8fafc;
      }
    }
    
    :deep(img) {
      max-width: 100%;
      height: auto;
      border-radius: 6px;
      margin: 1em 0;
    }
    
    :deep(hr) {
      border: 0;
      border-top: 1px solid #e2e8f0;
      margin: 1.5em 0;
    }
  }

  .loading-content {
    padding: 16px;
    background-color: white;

    .typing-indicator {
      display: flex;
      gap: 4px;

      span {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #4e7df9;
        display: inline-block;
        animation: bounce 1.4s infinite ease-in-out;

        &:nth-child(1) {
          animation-delay: -0.32s;
        }

        &:nth-child(2) {
          animation-delay: -0.16s;
        }
      }
    }
  }
}

.input-area {
  padding: 15px 45px 15px 24px;
  background-color: white;
  border-top: 1px solid #e2e8f0;

  .input-container {
    display: flex;
    background-color: #f1f5f9;
    border-radius: 8px;
    padding: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

    .question-input {
      flex: 1;
      background-color: transparent;
      border: none;
      padding: 12px 16px;
      color: #2d3748;
      font-size: 0.95rem;

      &::placeholder {
        color: #94a3b8;
      }

      &:focus {
        outline: none;
      }
    }

    .send-button {
      background-color: #4e7df9;
      border: none;
      border-radius: 6px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 5px rgba(78, 125, 249, 0.3);

      i {
        color: white;
        font-size: 1.2rem;
      }

      &:hover {
        background-color: #3b6ef6;
        transform: translateY(-1px);
      }

      &:disabled {
        background-color: #cbd5e1;
        cursor: not-allowed;
        opacity: 0.7;
        box-shadow: none;
      }
    }
  }

  .input-hint {
    text-align: right;
    color: #94a3b8;
    font-size: 0.8rem;
    margin-top: 6px;
    padding-right: 8px;
  }
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1.0);
  }
}

@media (max-width: 768px) {

  .user-message,
  .ai-message {
    padding-left: 0;
    padding-right: 0;
  }
}

:deep(.katex) {
  /* 数学公式样式 */
  font-size: 1.2em;
  font-family: KaTeX_Main, 'Times New Roman', serif;
  line-height: 0 !important;
}

:deep(.katex .mfrac) {
  /* 分数样式 */
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  margin: 0 0.1em;
}

:deep(.katex .mfrac .frac-line) {
  width: 100%;
  display: inline-block;
  border-bottom-style: solid;
  border-bottom-width: 0.04em;
  min-height: 0.04em;
}

:deep(.katex .mfrac .frac-line::after) {
  content: '';
  display: block;
  margin-top: -0.04em;
}

:deep(.katex .mfrac .mfrac-numerator, .katex .mfrac .mfrac-denominator) {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 85%;
}

:deep(.katex .mfrac .mfrac-numerator) {
  padding-bottom: 0.25em;
}

:deep(.katex .mfrac .mfrac-denominator) {
  padding-top: 0.25em;
}

:deep(.katex .msupsub) {
  text-align: left;
}

:deep(.katex .mspace) {
  margin-right: 0.15em;
  margin-left: 0.15em;
}

:deep(.katex .reset-textstyle.scriptstyle) {
  font-size: 0.7em;
}

:deep(.katex .reset-textstyle.scriptscriptstyle) {
  font-size: 0.5em;
}

:deep(.katex-display) {
  /* 数学公式容器样式 */
  margin: 1.5em 0;
  padding: 1em;
  overflow-x: auto;
  overflow-y: visible;
  text-align: center;
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: inset 0 0 5px rgba(0,0,0,0.05);
}

:deep(.katex-display > .katex) {
  /* 显示模式下的额外间距 */
  display: inline-block;
  text-align: center;
  padding: 0.2em 0;
}

:deep(.katex .mord.text) {
  /* 文本内容间距 */
  margin-right: 0.15em;
  margin-left: 0.15em;
}

:deep(.markdown-body) {
  /* Markdown 内容样式 */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
  line-height: 1.8;
  word-wrap: break-word;
  padding: 20px;
  color: #2c3e50;
}

:deep(.markdown-body h1) {
  font-size: 2em;
  margin-bottom: 1em;
  color: #1a202c;
  font-weight: 600;
}

:deep(.markdown-body h2) {
  font-size: 1.5em;
  margin: 1.5em 0 0.5em;
  color: #2d3748;
}

:deep(.markdown-body ol) {
  padding-left: 1.5em;
  margin: 1em 0;
  list-style-type: decimal;
}

:deep(.markdown-body li) {
  margin: 0.8em 0;
  line-height: 1.6;
  color: #4a5568;
}

:deep(.markdown-body li strong) {
  color: #2d3748;
  font-weight: 600;
}

:deep(.message-content) {
  /* 消息内容样式 */
  padding: 1.5em;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

:deep(.ai-content) {
  /* AI回答内容样式 */
  background-color: white;
  padding: 1.5em;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  
  p {
    margin: 1em 0;
    line-height: 1.8;
  }
}

// 添加响应式样式
@media (max-width: 768px) {
  :deep(.katex) {
    font-size: 1em;
  }
  
  :deep(.markdown-body) {
    padding: 15px;
  }
  
  :deep(.message-content) {
    padding: 1em;
  }
}
</style>
